/* Standaard WhatsApp-velden — overal dezelfde lay-out: template → bericht → tags → link
 * invoegen. Zie /app/docs/COMMUNICATION.md */
import { useRef } from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Link2 } from "lucide-react";
import { TagChips, TemplatePicker } from "./commShared";

export default function WhatsAppFields({
  message, setMessage, tags = [], templates = true, onTemplateSubject, onTemplateApplied,
  rows = 6, placeholder = "Hoi {voornaam}, …", testId = "comm-wa", children, label = "Bericht *",
}) {
  const ref = useRef(null);
  const insert = (text) => {
    const el = ref.current;
    if (!el) { setMessage((message || "") + text); return; }
    const s = el.selectionStart ?? (message || "").length;
    const e = el.selectionEnd ?? s;
    setMessage((message || "").slice(0, s) + text + (message || "").slice(e));
    setTimeout(() => { el.focus(); el.setSelectionRange(s + text.length, s + text.length); }, 0);
  };
  const insertLink = () => {
    const url = window.prompt("Plak de link (URL):");
    if (!url) return;
    insert(url.trim().startsWith("http") ? url.trim() : `https://${url.trim()}`);
  };
  return (
    <div className="space-y-3">
      {templates && <TemplatePicker kind="whatsapp" testId={`${testId}-template-select`}
        onPick={(t) => { setMessage(t.body || ""); if (t.subject && onTemplateSubject) onTemplateSubject(t.subject); onTemplateApplied?.(t); }} />}
      <div className="space-y-1.5">
        <Label>{label}</Label>
        <Textarea ref={ref} rows={rows} value={message} onChange={(e) => setMessage(e.target.value)}
          placeholder={placeholder} data-testid={`${testId}-message`} />
        <div className="flex flex-wrap items-center gap-2">
          <TagChips tags={tags} onInsert={insert} testId={`${testId}-tags`} />
          <button type="button" onClick={insertLink} data-testid={`${testId}-insert-link`}
            className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700 hover:bg-emerald-100">
            <Link2 className="h-3 w-3" /> Link invoegen
          </button>
        </div>
      </div>
      {children}
    </div>
  );
}
